function checkClientIsOffline(): boolean {
  return typeof navigator !== 'undefined' && navigator.onLine === false;
}

export default checkClientIsOffline;
